import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VideoEngineUpdateState } from "userful-chronos-app-common-js/dist/models/config/packageUpdates";
import { STRINGID_NOT_SET } from "userful-chronos-app-common-js/dist/models/common";

const initStatus = (): VideoEngineUpdateState => ({
    id: STRINGID_NOT_SET,
    status: "NONE",
    msg: "",
    packages: {
        packagesToInstall: [],
        packagesToUpdate: [],
        updateNoticeHTML: "",
        failureMessage: "",
    },
    initiator: "",
    start: 0,
});

const initialState: {
    updateStatus: VideoEngineUpdateState;
} = {
    updateStatus: initStatus(),
};

export const updateProgressSlice = createSlice({
    name: "updateProgressSlice",
    initialState,
    reducers: {
        setStatus: (state, action: PayloadAction<VideoEngineUpdateState>) => {
            state.updateStatus = action.payload;
        },
    },
});

export const updateInProgressSliceActions = updateProgressSlice.actions;

export default updateProgressSlice.reducer;
